import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BotonWhatsapp from '../components/boton_whatsapp';
import Contacto from '../components/contacto';
import Footer from '../components/footer';
import Menu from '../components/menu';

const temaActual = {
  bg: 'bg-white',
  border: 'border-blue-200',
  accentBg: 'bg-blue-600',
  gradient: 'from-blue-500 to-blue-700'
};

const imagenesProyectos = Array.from(
  { length: 25 },
  (_, index) => `/images/nuestros_proyectos/nuestro_proyecto_${index + 1}.jpeg`
);

const NuestrosProyectos = ({ onChangeLanguage }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const offsetPosition = section.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      return;
    }

    navigate(`/${lang}`, { state: { scrollToSection: sectionId } });
  };

  const navegarAProyectos = () => scrollToSection('proyectos');

  return (
    <div className="min-h-screen bg-white text-gray-800">
      <Menu
        temaActual={temaActual}
        onChangeLanguage={onChangeLanguage}
        onNavigateToProjects={navegarAProyectos}
        onNavigateToSection={scrollToSection}
      />

      <main>
        <section id="proyectos" className="px-4 pb-20 pt-32">
          <div className="container mx-auto">
            <h1 className="mb-12 bg-gradient-to-r from-blue-500 to-blue-700 bg-clip-text text-center text-4xl font-bold text-transparent">
              {t('projects.title')}
            </h1>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {imagenesProyectos.map((imagen, index) => (
                <article
                  key={imagen}
                  className="group overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-black/5 transition duration-300 hover:-translate-y-1 hover:shadow-2xl"
                >
                  <img
                    src={imagen}
                    alt={`${t('projects.title')} ${index + 1}`}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                </article>
              ))}
            </div>
          </div>
        </section>
        <Contacto temaActual={temaActual} />
      </main>

      <Footer
        onNavigateToProjects={navegarAProyectos}
        onNavigateToSection={scrollToSection}
      />
      <BotonWhatsapp />
    </div>
  );
};

export default NuestrosProyectos;
